import React from "react";

export const InvertAbout = (props) => {
  return (
    <div id="about-invert">
      <div className="container">
        <div className="row">
        <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>{props.data ? props.data.title : "loading..."}</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src={props.data ? props.data.img : "/"} className="img-responsive" alt="" />
          </div>

        </div>
      </div>
    </div>
  );
};  
